import { createContext, useContext, useState, useEffect, useCallback, useMemo } from 'react';

const ThemeContext = createContext(null);

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [isDark, setIsDark] = useState(() => {
    const saved = localStorage.getItem('theme_v2');
    return saved ? saved === 'dark' : false; // Default to light (Moderne coloré)
  });

  useEffect(() => {
    localStorage.setItem('theme_v2', isDark ? 'dark' : 'light');
    
    document.body.className = isDark ? 'theme-dark' : 'theme-light';
  }, [isDark]);

  const toggleTheme = useCallback(() => setIsDark(d => !d), []);

  const value = useMemo(() => ({ isDark, toggleTheme }), [isDark, toggleTheme]);

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeContext;
